import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import JavaScript files for translations
import enTranslation from './locales/en/translation';
import esTranslation from './locales/es/translation';
import ptTranslation from './locales/pt/translation';

const resources = {
  en: {
    translation: enTranslation
  },
  pt: {
    translation: ptTranslation
  },
  es: {
    translation: esTranslation
  }
};

// Available languages
export const languages = ['en', 'es'];

i18n
  // Add the language detector
  .use(LanguageDetector)
  // Pass i18n to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: languages,
    
    // Enhanced detection configuration
    detection: {
      // Order matters - it will try sources in this order
      // Exclude navigator/htmlTag so default falls back to 'es' for new users
      order: ['querystring', 'localStorage', 'sessionStorage'],
      
      // Keys to lookup language in sources
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'language',
      lookupSessionStorage: 'language',
      
      // Cache user language
      caches: ['localStorage'],
      
      // Only use navigator language if it's in our supported languages
      checkWhitelist: true
    },
    
    // Other configuration
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    }
  });

// Export a function to manually change language
export const changeLanguage = (lng) => {
  return i18n.changeLanguage(lng);
};

export default i18n;
// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

// // Import your translation files
// import enTranslation from './locales/en/translation.js';
// import esTranslation from './locales/es/translation.js';

// const resources = {
//   en: {
//     translation: enTranslation
//   },
//   es: {
//     translation: esTranslation
//   }
// };

// i18n
//   // detect user language
//   .use(LanguageDetector)
//   // pass the i18n instance to react-i18next
//   .use(initReactI18next)
//   // init i18next
//   .init({
//     resources,
//     fallbackLng: 'en',
//     debug: true,
//     interpolation: {
//       escapeValue: false, // not needed for react as it escapes by default
//     },
//     detection: {
//       order: ['localStorage', 'navigator'],
//       lookupLocalStorage: 'language',
//       caches: ['localStorage'],
//     }
//   });

// export default i18n;